import { create } from "zustand";

const initialState = {
  loading: false,
  success: false,
  isLogin: false,
  userCreated: false,
  errorName: null,
  notify: "",
  errors: {
    name: "",
    errorCode: "",
    message: "",
  },

  product: false,
  products: false,
};

const store = (set, get) => ({
  ...initialState,
  shopResetAll: () => set({ ...initialState }),

  setNotify: (notify) => {
    set({ notify });
  },
});

const useAppStore = create(store);
export default useAppStore;
